import {Component} from '@angular/core';
import {LoggedInStatus, LoginService} from '@uofu-uss/ngx-auth';
import { HttpErrorResponse } from '@angular/common/http';
import {first, Observable} from 'rxjs';
import {NotificationService} from '@uofu-uss/angular-util';
import {PersonIconComponent} from "../../svg/person-icon/person-icon.component";
import {NgClass} from "@angular/common";
import {UsernameComponent} from "../username/username.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    PersonIconComponent,
    NgClass,
    UsernameComponent,
    RouterLink
  ]
})
export class NavbarComponent {

  isCollapsed = true;

  constructor(private readonly loginService: LoginService,
              private readonly notificationService: NotificationService) {
  }

  logout(): void {
    const observer = {
      next: () => {
      },
      error: (error: HttpErrorResponse) => {
        this.notificationService.addError(error.message);
      }
    };
    const observable: Observable<LoggedInStatus> = this.loginService.logout().pipe(first());
    observable
      .subscribe(observer);
  }
}
